import type React from "react";
import {memo} from "react";

import {InfoIcon, QuestionSolidIcon} from "../../react/components/Icons";
import {Tooltip} from "../ui/tooltip";

export type Props = {
    label: React.ReactNode;
    icon?: "info" | "question";
};

const PopoverInfo: React.FC<Props> = ({label, icon = "question"}) => {
    return (
        <Tooltip interaction label={label}>
            {icon === "question" ? (
                <QuestionSolidIcon color="blueGray.400" size="xs" />
            ) : (
                <InfoIcon color="blueGray.400" size="xs" />
            )}
        </Tooltip>
    );
};

export default memo(PopoverInfo);
